const CONTEXT = '/api'

export const ENDPOINTS = {
  validateHash: CONTEXT + '/validatehash',
  register: CONTEXT + '/register'
}
